export const colorBlueAccent = "rgba(66, 135, 245, 1)";
export const colorBlack = "rgba(18, 18, 18, 1)";
export const colorRed = "rgba(255, 0, 0, 1)";
export const colorWhite = "rgba(240, 240, 240, 1)";
export const colorBackground = "rgba(40, 40, 40, 1)";
export const colorGray = "rgba(18, 18, 18, .5)";